export default {
  nav:[
    {
      name: "HOME",
      path: "/",
      children: []
    },
    {
      name: "ABOUT US",
      path: "/company",
      children: [
        {
          name: "Company Profile",
          path: "/company/info"
        },
        {
          name: "Company History",
          path: "/company/time"
        },
        {
          name: "Tongzhou Factory",
          path: "/company/factory"
        }
      ]
    },
    {
      name: "COMPANY NEWS",
      path: "/company/news",
      children: [
        {
          name: "BXET News",
          path: "/company/news"
        },
        {
          name: "Industry News",
          path: "/dynamics"
        },
      ]
    },
    {
      name: "PRODUCT CENTER",
      path: "/product?id=mini&index1=0",
      children: [
        {
          name:'Mini LED',
          path: "/product?id=mini&index1=0"
        },
        {
          name:'Micro LED',
          path: ""
        },
        {
          name:'Force Touch',
          path: "/product?id=force"
        },
      ]
    },
    {
      name: "JOIN US",
      path: "/job",
      children: [
        {
          name: "Social Requirement", //
          type:"2",
          path: "https://www.zhaopin.com/companydetail/CZL1368651860.htm?refcode=4019&srccode=401901&preactionid=247fd5fc-e2cc-4226-88b9-cfefcaddf5ef"
        },
        {
          name: "Campus Requirement",
          path: "/job/campusrecruitment"
        }
      ]
    },
    {
      name: "CONTACT US",
      path: "/contactus",
      children: [
        {
          name: "Contact Information",
          path: "/contactus"
        },
        {
          name: "Technical Advice",
          path: "/ContactForm"
        },
        {
          name: "Sample Application",
          path: "/ContactForm2"
        },
      ]
    },
  ],
  swiperList: [
    {
      img: require("@/assets/img/banner1.png"),
      path: "",
      title: 'Continuous leading technology innovation capabilities to become a global leader in Mini/Micro LED solution!',
      // content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
    },
    {
      img: require("@/assets/img/banner2.png"),
      path: "",
      title: 'Provide customers with the best solutions and create the ultimate experience.',
      // content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
    },
    {
      img: require("@/assets/img/banner3.png"),
      path: "",
      title: '2022Y，Tongzhou factory has started mass production',
      // content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
    },
  ],
  factoryTitle:"BXET Factory",
  factoryDesc:"Beijing Xinneng Electronic Technology Co., Ltd. is located in Fanghe Zhengyuan Industrial Zone, Tongzhou District, Beijing, and began production in 2022. The Tongzhou factory mainly produces Mini LED direct display PKG products, which use AM drive mode and the company's original LoS PKG structure, with characteristics such as small PKG size, good transparency, and low power consumption. In addition to being applicable to ordinary indoor and outdoor large displays, its advantages are more prominent in professional and segmented fields such as transparent display.",
  companyDesc:'Company Profile',
  companyTitle:'Beijing Xinneng Electronic Technology Co., Ltd',
  companyInfo:`Beijing Xinneng Electronic Technology Co., Ltd (BXET) is headquartered in Beijing. And has a mini led direct display package factory in Tongzhou. The R&D team is in South Korea and also has an office in Shenzhen. BXET is a chip design company controlled by TOREAD. Its main business is analog chip design and related IC and module sales. Its main products include Mini LED display driver IC, module and force touch IC etc. BXET R&D team has accumulated corresponding products & technology and patent reserves in analog drive chip design & development and module package & test. BXET's display driver chip products adopt its unique active matrix (AM) driving mode, which is a technological leader in the field of mini led direct display and BLU. BXET's Mini led AM drive IC has been recognized in the display industry in China and South Korea and has established close cooperative relations between customers in the industry.`,
  historyTitle:"Company History",
  historyList: [
    {
      id: "1",
      title: `<p>Beijing Tongzhou factory construction started</p>`,
      year: "2022",
    },
    {
      id: "2",
      title: 
      `
      <p>AXET office moved to Beijing and company name changed to Beijing Xinneng Electronic Technology Co., Ltd (BXET)</p>
      <p>FALD Controller Development (AX9000)</p>
      <p>Pixel PKG Development  (AXP000A)</p>
      `,
      year: "2021",
    },
    {
      id: "3",
      title: 
      `
      <p>Pixel PKG Development (AXP000)</p>
      <p>SCAN/DATA Driver IC Development (AX8000)</p>
      <p>Dimming Driver IC Development</p>
      `,
      year: "2020",
    },
    {
      id: "4",
      title: 
      `
      <p>Force Sensor ROIC Development (SI0924F)</p>
      <p>μLED Backplane IC Development</p>
      <p>Anhui Xinneng Electronic Technology Co., Ltd (AXET) established</p>
      `,
      year: "2019",
    },
    {
      id: "5",
      title: 
      `
      <p>Developed backplane IC for μLED smart vehicle lighting with medium-sized company L</p>
      `,
      year: "2018",
    },
    {
      id: "6",
      title: 
      `
      <p>SI2330 (μLED CMOS Silicon Backplane IC, Display) Development</p>
      `,
      year: "2016",
    },
    {
      id: "7",
      title: 
      `
      <p>Development LCD Driver IC for Automotive Navigation</p>
      `,
      year: "2013",
    },
    {
      id: "8",
      title: 
      `
      <p>Siliconinside co., Ltd established</p>
      `,
      year: "2009",
    },
  ],
  factoryImg:require("@/assets/img/factory_en.jpg"),
  hr:{
    title:"HR Team Information",
    one:"Campus recruitment is being planned. Schools or organizations that want to cooperate should contact us at any time!",
    two:"ZHANG YONG JIE (HR team leader) - 13668048025 - yongjie.zhang@bx-vision.cn",
    three:"ZHANG CHUN JI (HR deputy section chief) - 19901469540 - chunji.zhang@bx-vision.cn",
  },
  mapInfo:[
    { point1:116.439133,point2:39.927164,mapName:"BXET",mapTitle:"Rm.21003, BLK B, Galaxy SOHO",
      name:"Beijng Office",title:"Beijing Xinneng Electronic Technology Co., Ltd",add:"Rm.21003, BLK B, Galaxy SOHO, No.2 Nanzhugan Hutong, Dongcheng",pc:'10010',tel:"010-59576010/6011",email:"bxet@bx-vision.cn"},
    { point1:116.7286,point2:39.861089,mapName:"BXET M2 Factory",mapTitle:"Plant 5, No. 16, Guanghua Road, Tongzhou",
      name:"Beijing Factory",title:"BXET Tongzhou M2 Factory",add:"Plant 5, No. 16, Guanghua Road, Tongzhou Industrial Development Zone, Zhangjiawan Town, Tongzhou District, Beijing",pc:'102299',tel:"010-59576010/6011",email:"bxet@bx-vision.cn"},
    { point1:113.9586,point2:22.546662,mapName:"BXET Shenzhen office",mapTitle:"Rm.3309, BLK B, Dachong Business Center",
      name:"Shenzhen Office",title:"BXET Shenzhen office",add:"Rm.3309, BLK B, Dachong Business Center, No.9676 Shennan Road, Nanshan District, Shenzhen",pc:'518000',tel:"010-59576010/6011",email:"bxet@bx-vision.cn"},
    { point1:127.04138980210135,point2:37.48409036052456,mapName:"SILICONINSIDE",mapTitle:"2F, Inhwan Building, 163, Nonhyeon-ro, Seocho-gu, Seoul, Republic of Korea",
      name:"Korea R&D",title:"SILICONINSIDE",add:"2F, Inhwan Building, 163, Nonhyeon-ro, Seocho-gu, Seoul, Republic of Korea",pc:'06740',tel:"02-6447-1709",email:"sales@siliconinside.co.kr"},
  ],
  advice:{
    title:'Technical Advice',
    name:"Name (Required)",
    phone:"Phone Number (Required)",
    email:"Email (Required)",
    company:"Company (Required)",
    content:"Comment (Required)",
    submit:"Submit",
    name_pl:"Please fill in your name.",
    phone_pl:"Please fill in your phone number.",
    email_pl:"Please fill in your email address.",
    company_pl:"Please fill in your company name.",
    content_pl:"Please fill in what you want to ask. ",
  },
  application:{
    title:'Sample Application',
    name:"Name (Required)",
    phone:"Phone Number (Required)",
    email:"Email (Required)",
    company:"Company (Required)",
    content:"Application Message (Required)",
    submit:"Submit",
    name_pl:"Please fill in your name.",
    phone_pl:"Please fill in your phone number.",
    email_pl:"Please fill in your email address.",
    company_pl:"Please fill in your company name.",
    content_pl:"Please fill in what you want to ask. ",
  },
  productTitle:"PRODUCT CENTER",
  productList:{
    mini: [
      {
        name: 'Mini LED BLU',
        img:require('@/assets/img/product_detail1.jpg'),
        type: [
          {
            name: 'Dimming Driver IC',
            tableId:1,
            list: [
              { a: 'AX3000', b: '2mm x 2mm DFN 8-Lead Cu/Ni/Au Bump',c: "4-CH", d: 'Typ.5.0V',e:"Typ. 5.0V",f:'21mA',g:'30V',h:'±3%',i:"±3%" },
              { a: 'AX3100', b: '2mm x 2mm DFN 10-Lead',c: "4-CH", d: 'Typ.5.0V',e:"3.3V/5.0V",f:'75mA',g:'40V',h:'±3%',i:"±3%" },
            ]
          },
          {
            name: 'Dimming Controller',
            tableId:2,
            list: [
              { a: 'AX9000', b: '14mm x 14mm LQFP 100-Lead',c: "SCAN 32-CH, DATA 32-CH", d: 'Typ. 5.0V',e:"3.3V",f:'SPI',g:'4,096 D/Z (64 x 64)',h:'7-bit'},
            ]
          }
        ]
      },
      {
        name: 'Mini LED Direct Display',
        img:require('@/assets/img/product_detail1.jpg'),
        type: [
          {
            name: 'Pixel Driver IC',
            tableId:3,
            list: [
              { a: 'AX2000', b: 'Bump (Cu/Ni/Au or Cu/SnAg)',c: "3-CH (R/G/B)", d: 'Typ. 5.0V',e:"Typ. 5.0V",f:"600/429/375 uA",g:'10-bit'},
              { a: 'AX2000A', b: 'Bump (Cu/Ni/Au or Cu/SnAg)',c: "3-CH (R/G/B)", d: 'Typ. 5.0V',e:"Typ. 5.0V",f:"9.61/6.89/6.03 mA",g:'10-bit'},
              { a: 'AX2200', b: 'Bump (Cu/Ni/Au or Cu/SnAg)',c: "3-CH (R/G/B)", d: '3.3V',e:"3.3V",f:"9.61/6.89/6.03 mA",g:'14-bit'},
            ]
          },
          {
            name: 'IC embedded pixel IC',
            tableId:4,
            list: [
              { a: 'AXP000', b: '0.8mm x 0.8mm (4-Pin)',c: "Typ. 5.0V", d: 'Typ. 5.0V',e:"6/14/2 mcd (T.B.D)",f:'R:G:B = 3:7:1',g:'10-bit'},
              { a: 'AXP000A', b: '0.8mm x 0.8mm (4-Pin)',c: "Typ. 5.0V", d: 'Typ. 5.0V',e:"192/224/64 mcd (T.B.D)",f:'R:G:B = 3:7:1',g:'10-bit'},
              { a: 'AXP020', b: '0.9mm x 1.15mm (5-Pin)',c: "Typ. 5.0V", d: 'Typ. 3.3V',e:"192/224/64 mcd (T.B.D)",f:'R:G:B = 3:7:1',g:'14-bit'},
            ]
          },
          {
            name: 'SCAN/DATA Driver IC',
            tableId:5,
            list: [
              { a: 'AX8000', b: '8mm x 8mm QFN 64-Lead',c: "32-CH", d: 'Typ. 5.0V',e:"Typ. 3.3V",f:'Cascaded SPI',g:'6-bit'},
            ]
          }
        ]
      },
    ],
    force: [
      {
        name: 'Force Touch',
        img:require('@/assets/img/product_detail2_en.jpg'),
        type: [
          {
            name: 'Force Touch',
            tableId:6,
            list: [
              { a: 'AX1002', b: '4mm x 4mm QFN 32-Lead 2.65mm x 1.63mm WLCSP 24-Lead',c: "Typ. 3.3V", d: '1.65 ~ 3.6V',e:"8-CH (QFN) 4-CH (WLCSP)",f:'I2C',g:'14-bit',h:'Spiral Coil Pattern on PCB'},
            ]
          },
        ]
      },
    ]
  },
  studentTitle:'Campus Recruitment',
  contactTitle:'CONTACT US',
}



// WEBPACK FOOTER //
// ./src/lang/en.js